// extracted by mini-css-extract-plugin
export default {"wrapper":"auth_wrapper__NFD9D","errorWrapper":"auth_errorWrapper__FQWgr","appName":"auth_appName__cViff","notice":"auth_notice__QTkDp","actions":"auth_actions__8jvIl"};